import { createMuiTheme } from '@material-ui/core';

import { CONSTANTS } from './constants';

export const FontSizes = {
  font: 15,
  connectionFormSize: 13,
  datePickerFont: 11,
  modalTitleFont: 24,
  treeItem: 14,
  fontWeight: {
    normal: 400,
    bold: 600,
  },
  size: {
    smallest: 11,
    small: 12,
    normal: 15,
    medium: 16,
    headerSize: 18,
  },
};

export const Width = {
  filterBlockWdith: '650px',
};

const Spacing = (size: any) => [0, 2, 4, 6, 8, 12, 16, 18, 20, 24, 30, 36, 40, 64][size];

export const BorderWidthWithColor = (borderWidht: number, color: string) => {
  return `${borderWidht}px solid ${color}`;
};

export const TableColors = {
  rowBorderColor: '#dde2eb',
};

export const TreeColors = {
  hover: '#ecf1f4',
  checked: '#ecf1f4',
  checkedHover: '#dce5eb',
};

export enum FilterBackgrounds {
  'FirstChild' = '#f6f2f9',
  'FirstChildDark' = '#8537bc',
  'SecondChild' = '#eff7f6',
  'SecondChildDark' = '#00a286',
  'ThirdChild' = '#eff7f9',
  'ThirdChildDark' = '#0094c7',
  'FourthChild' = '#fbf7f2',
  'FourthChildDark' = '#f9de08',
  'FifthChild' = '#f7f0f1',
  'FifthChildDark' = '#b43e4f',
}

export enum Table {
  'FirstChild' = '#f6f2f9',
  'FirstChildDark' = '#8537bc',
  'SecondChild' = '#eff7f6',
  'SecondChildDark' = '#00a286',
  'ThirdChild' = '#eff7f9',
  'ThirdChildDark' = '#0094c7',
  'FourthChild' = '#fbf7f2',
  'FourthChildDark' = '#f9de08',
}

export enum ResolutionColors {
  Accepted = '#2E7D32',
  AcceptedHover = '#27642A',
  Rejected = '#C62828',
  RejectedHover = '#A61E1E',
  Pending = '#F9A825',
  PendingHover = '#D68F1E',
}

export const treeMapColors: string[] = [
  '#874db7',
  '#9461bf',
  '#a078be',
  '#aa82c3',
  '#b48cc8',
  '#be96cd',
  '#c8a0d2',
  '#d2aad7',
  '#dcb4dc',
  '#e6bee1',
];

export const mainTheme = createMuiTheme({
  typography: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: FontSizes.font,
    caption: {
      fontSize: '10px',
    },
  },
  palette: {
    primary: {
      main: '#006dc6',
      dark: '#23303e',
      light: '#0094c7',
      contrastText: '#fff',
    },
    secondary: {
      main: '#f2f2f2',
      dark: '#999',
      light: '#808080',
      contrastText: '#32325c',
    },
    text: {
      primary: '#666',
      secondary: '#000',
    },
    background: {
      default: '#f2f2f2',
    },
    divider: '#DEE0E2',
  },
  spacing: Spacing,
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          height: '100%',
        },
        body: {
          minHeight: '100%',
          '& #root': {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          },
        },
      },
    },
    MuiTypography: {
      body1: {
        fontSize: FontSizes.font,
      },
      body2: {
        fontSize: FontSizes.font,
      },
      root: {
        fontSize: FontSizes.font,
      },
    },
    MuiFormControl: {
      root: {
        position: 'relative',
        width: '100%',
        paddingTop: 0,
      },
    },
    MuiFormLabel: {
      root: {
        color: '#666',
        fontSize: FontSizes.font - 2,
        textTransform: 'capitalize',
        position: 'relative',
      },
    },
    MuiInputLabel: {
      formControl: {
        position: 'absolute',
      },
      shrink: {
        transform: 'inherit',
        marginBottom: '6px',
      },
      outlined: {
        transform: 'translate(10px, 10px) scale(1)',
      },
    },
    MuiOutlinedInput: {
      root: {
        padding: '0 10px',
      },
      input: {
        padding: '4px 0',
        width: '100%',
      },
    },
    MuiInputBase: {
      root: {
        background: '#fff',
        padding: '0 10px',
        fontSize: '14px',
      },
      input: {
        height: '40px',
        padding: 0,
        width: '100%',
      },
    },
    MuiSelect: {
      select: {
        padding: 0,
      },
      icon: {
        right: 2,
      },
      outlined: {
        '&.MuiSelect-outlined': {
          paddingRight: Spacing(6),
        },
      },
    },
    MuiLink: {
      root: {
        color: 'primary',
      },
    },
    MuiSlider: {
      track: {
        color: '#006DC6',
      },
      rail: {
        color: '#ABC4D9',
      },
      thumb: {
        color: '#006DC6',
      },
    },
    MuiBreadcrumbs: {
      root: {
        backgroundColor: '#23303e',
        color: '#fff',
        paddingLeft: '30px',
        paddingRight: '30px',
        display: 'flex',
        height: CONSTANTS.TOOLBAR_HEIGHT,
        alignItems: 'center',
        fontSize: '18px',
        '& a': {
          textDecoration: 'none',
          color: '#fff',
        },
      },
    },
    MuiChip: {
      root: {
        padding: Spacing(0),
        margin: Spacing(1),
        height: Spacing(9),
      },
    },
  },
});
